import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'
import {alertActions, dataActions} from '../../actions'
import * as R from 'ramda'
import WindowedSelect from 'react-windowed-select'
import {Box, IconButton, Tooltip} from '@material-ui/core'

// Copy Department Virtual Link Icon
import InsertLinkIcon from '@material-ui/icons/InsertLink'

const customStyles = () => ({
    option: (provided, state) => ({
        ...provided,
        borderRadius: 0,
        width: state.selectProps.width,
        color: '#098447',
        padding: 0,
    }),
    control: () => ({
        // none of react-select's styles are passed to <Control />
        display: 'flex',
        width: '230px',
        height: '24px',
        color: 'white',
        background: '#025420',
    }),
    singleValue: base => ({
        ...base,
        width: '230px',
        padding: 0,
        borderRadius: 0,
        background: '#025420',
        color: 'white',
        display: 'flex',
        fontSize: '0.8rem',
        fontWeight: '600',
    }),
    menu: provided => ({
        ...provided,
        width: '230px',
        padding: '0 0 0 5px',
        fontSize: '0.8rem',
        fontWeight: '600',
    }),
    indicatorSeparator: () => {},
    dropdownIndicator: defaultStyles => ({
        ...defaultStyles,
        color: 'white', // your changes to the arrow
        '&:hover': {
            opacity: '0.8',
            color: 'white',
        },
    }),
    input: base => ({
        ...base,
        padding: '0 0 10px 0',
        color: '#fff',
    }),
})

const SelectDeptButton = props => {
    const {
        token,
        roles,
        userrole,
        setactivedepartment,
        activedepartment,
        departmentslist,
        copysuccess,
        copyfailure,
    } = props

    // Display active departments only
    const activeDepartmentslist = departmentslist.filter(
        dept => dept.status === 'A'
    )

    const getOption = activeDepartmentslist.find(
        dept => dept.deptId === activedepartment
    )

    const selectedOption = {
        value: activedepartment ? activedepartment : '0216',
        label: getOption ? getOption.name : 'UCD3 Test',
    }
    const [deptsarray, setDepts] = useState([])

    const handleChange = newdepartment => {
        if (newdepartment.value !== activedepartment) {
            setactivedepartment(token, newdepartment)
        }
    }

    // virtual event link copy to clipboard function
    const copyToClipboard = str => {
        navigator.clipboard.writeText(str).then(
            function() {
                copysuccess(`Copied ${str} to clipboard`)
            },
            function() {
                copyfailure(`Failed to copy ${str} to clipboard`)
            }
        )
    }

    const virtualeventlink =
        process.env.REACT_APP_VIRTUAL_EVENT_APP_URL + `/${selectedOption.value}`

    useEffect(() => {
        if (
            !R.isNil(activeDepartmentslist) &&
            !R.isEmpty(activeDepartmentslist)
        ) {
            const nonsuperadmindeptlist = !R.isEmpty(roles)
                ? 'admin' in roles
                    ? 'creator' in roles
                        ? roles.admin.concat(roles.creator)
                        : [...roles.admin]
                    : 'creator' in roles
                    ? [...roles.creator]
                    : []
                : []

            const superadmindeptlist = activeDepartmentslist.map(
                element => element.deptId
            )
            const userdepartments =
                userrole === 'Super Admin'
                    ? superadmindeptlist
                    : nonsuperadmindeptlist

            let deptDetails
            if (Array.isArray(userdepartments)) {
                userdepartments.forEach(element => {
                    deptDetails = activeDepartmentslist.find(
                        dept => dept.deptId === element
                    )
                    if (!R.isNil(deptDetails) && !R.isEmpty(deptDetails)) {
                        deptsarray.push({
                            value: deptDetails.deptId,
                            label: deptDetails.name,
                        })
                    }
                })
            }

            // remove duplicate entries
            const filteredArr = Array.from(
                new Set(deptsarray.map(a => a.value))
            ).map(value => {
                return deptsarray.find(a => a.value === value)
            })
            //sort deduped array
            filteredArr.sort((a, b) => (a.label > b.label ? 1 : -1))

            setDepts([...filteredArr])

            if (!activedepartment) {
                setactivedepartment(token, filteredArr[0])
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [departmentslist])

    return (
        <Box style={{display: 'flex', flexDirection: 'row'}}>
            <Tooltip title="Copy Dept Event Link">
                <IconButton
                    style={{padding: '0px 5px', color: 'white'}}
                    onClick={event => {
                        event.stopPropagation()
                        copyToClipboard(virtualeventlink)
                    }}
                >
                    <InsertLinkIcon />{' '}
                </IconButton>
            </Tooltip>
            <WindowedSelect
                styles={customStyles()}
                options={deptsarray}
                isSearchable={true}
                onChange={handleChange}
                value={selectedOption}
                placeholder={'Default Department'}
                theme={theme => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        text: '#098447',
                        primary25: '#E1F0E9',
                        primary: '#E1F0E9',
                    },
                })}
            />
        </Box>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        roles: state.authentication.roles,
        admin: state.authentication.admin,
        departmentslist: state.departmentsdata.departmentslist,
        activedepartment: state.departmentsdata.activedepartment,
    }
}

const mapDispatchToProps = {
    setactivedepartment: (token, activedepartment) =>
        dataActions.setdepartmentsDataRequest(token, activedepartment),
    copysuccess: message => alertActions.success(message),
    copyfailure: message => alertActions.error(message),
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectDeptButton)
